import { app } from '../../app.module'
app
  // 投稿一覧モーダル
  .directive('postListModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog) => {
        $scope.showAccountDetailModalFlg = false
        /**
         * モーダルを閉じる処理
         */
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
